'use client'

import type { RuleDataRow } from '../../hooks/use-pricing-rule-data-formatter'

type Props = {
  ruleDataRow: RuleDataRow
}

const PriceRuleDataRow = ({ ruleDataRow }: Props) => {
  const getValue = () => {
    if (typeof ruleDataRow.value === 'string') return ruleDataRow.value
    if (ruleDataRow.value.length === 1) return ruleDataRow.value[0]

    return ruleDataRow.value
      .filter(data => data !== null)
      .map((valueItem, index) => <div key={index}>{`${valueItem};`}</div>)
  }

  return (
    <div className="available_discounts__pricing-rule-card-data-wrapper">
      <div className="available_discounts__pricing-rule-card-data">
        <div className="available_discounts__pricing-rule-card-data-label">{ruleDataRow.label}</div>
        <div className="available_discounts__pricing-rule-card-data-value">{getValue()}</div>
      </div>
    </div>
  )
}

export default PriceRuleDataRow
